export default __webpack_public_path__ + "static/media/biz-academy.55ce40f9.png";